module.exports = __webpack_public_path__ + "static/media/weather_sagittarius.166882bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/weather_sagittarius.svg
// module id = 536
// module chunks = 0